import { ProductId } from 'Utility/Product';
import { EventType } from '../Events/EventType';

export enum PopupOfferType {
    SUNDAY_OFFER = 'sunday_offer',
    PAYER_REACTIVATION_OFFER = 'reactivation_offer',
    STARTER_OFFER = 'starter_offer',
    EVENT_OFFER = 'event_offer',
}

export const PopupOfferTypeMap = {
    [PopupOfferType.SUNDAY_OFFER]: {
        [ProductId.SUNDAY_OFFER_V2_44_99]: ProductId.SUNDAY_OFFER_V2_44_99,
        [ProductId.SUNDAY_OFFER_V2]: ProductId.SUNDAY_OFFER_V2,
        [ProductId.SUNDAY_OFFER_3_9_99]: ProductId.SUNDAY_OFFER_3_9_99,
    },
    [PopupOfferType.PAYER_REACTIVATION_OFFER]: {
        [ProductId.PAYER_REACTIVATION_OFFER]: ProductId.PAYER_REACTIVATION_OFFER,
        [ProductId.PAYER_REACTIVATION_OFFER_2]: ProductId.PAYER_REACTIVATION_OFFER_2,
        [ProductId.PAYER_REACTIVATION_OFFER_3]: ProductId.PAYER_REACTIVATION_OFFER_3,
    },
    [PopupOfferType.STARTER_OFFER]: {
        [ProductId.SPECIAL_OFFER]: ProductId.SPECIAL_OFFER,
    },
    [PopupOfferType.EVENT_OFFER]: {
        [EventType.XMAS_2021]: [ProductId.XMAS_2021_OFFER],
        [EventType.EASTER_2022]: [ProductId.XMAS_2021_OFFER],
        [EventType.JUL4_2022]: [ProductId.JUL4_2022_OFFER],
        [EventType.HALLOWEEN_2022]: [ProductId.HALLOWEEN_2022_OFFER],
        [EventType.XMAS_2022]: [ProductId.XMAS_2021_OFFER],
        [EventType.VALENTINES_2023]: [ProductId.XMAS_2021_OFFER],
        [EventType.BLACKFRIDAY_2023]: [ProductId.XMAS_2021_OFFER],
        [EventType.XMAS_2023]: [ProductId.XMAS_2023_v1, ProductId.XMAS_2023_v2, ProductId.XMAS_2023_v3],
        [EventType.VALENTINES_2024]: [ProductId.XMAS_2021_OFFER],
        [EventType.EASTER_2024]: [ProductId.EASTER_2024_v1, ProductId.EASTER_2024_v2, ProductId.EASTER_2024_v3],
    },
};

export type PopupOffersOfType<T extends PopupOfferType> = typeof PopupOfferTypeMap[T];
